<template>
  <div id="app" ref="app">
    <top-header></top-header>
    <router-view v-if="showState"></router-view>
    <bott-footer v-if="showFooter"></bott-footer>
  </div>
</template>

<script>
import topHeader from './components/header.vue'
import bottFooter from './components/footer.vue'
export default {
  name: 'App',
  components: {
    topHeader,
    bottFooter
  },
  data () {
    return {
      showState: true,
      showFooter: true
    }
  },
  watch: {
    $route (to, from) {
      if (to.path === '/productTypeScreen') {
        this.showFooter = false
      } else {
        this.showFooter = true
      }
    }
  },
  created(){
    if (this.$route.path === '/productTypeScreen') {
      this.showFooter = false
    }else {
      this.showFooter = true
    }
  },
  provide () {
    return {
      reload: this.reload,
    }
  },
  methods: {
    reload () {
      this.showState = false;
      this.$nextTick(() => {
        this.showState = true;
      })
    }
  }
}
</script>

<style>
#app {
  font-family: "微软雅黑";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
}
</style>



// WEBPACK FOOTER //
// src/App.vue